// extracted by mini-css-extract-plugin
export var copyable = "_p-2";
export var explainable = "_p-1";
export var negative = "_p-3";
export var positive = "_p-4";
export var secondary = "_p-0";